import React, { useEffect, useState } from 'react';
import Prediction from '../Components/Prediction';
import Graph from '../Components/Graph';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { fetchPredictionHorse, } from '../../../redux/getReducer/getPrediction';
import { Carousel } from 'react-bootstrap';
import socket from '../../../../Socket';
import HowToRegister from '../Section/HowToRegister';
import NoResultCard from '../Components/NoResultCard';

// TEMP MOCK DATA FOR PREDICTION (safe to delete later)
const ENABLE_TEMP_PREDICTION_DATA = true;
const TEMP_PREDICTION_DATA = [
    [
        {
            racedata: {
                RaceNumber: 4,
                RaceNameModelData: {
                    NameEn: "Dubai Sprint Cup",
                    NameAr: "Dubai Sprint Cup",
                },
                RacehorsesData: new Array(12).fill({}),
            },
        },
        {
            votesdata: [
                { NameEn: "Thunder Sky", NameAr: "Thunder Sky", HorseNo: 3, OwnerSilkColor: "", votes: 120 },
                { NameEn: "Golden Dune", NameAr: "Golden Dune", HorseNo: 7, OwnerSilkColor: "", votes: 95 },
                { NameEn: "Blue Falcon", NameAr: "Blue Falcon", HorseNo: 1, OwnerSilkColor: "", votes: 70 },
                { NameEn: "Night Star", NameAr: "Night Star", HorseNo: 9, OwnerSilkColor: "", votes: 45 },
            ],
        },
        { totalvotes: 330 },
    ],
    [
        {
            racedata: {
                RaceNumber: 6,
                RaceNameModelData: {
                    NameEn: "Meydan Challenge",
                    NameAr: "Meydan Challenge",
                },
                RacehorsesData: new Array(10).fill({}),
            },
        },
        {
            votesdata: [
                { NameEn: "Rapid Fire", NameAr: "Rapid Fire", HorseNo: 5, OwnerSilkColor: "", votes: 88 },
                { NameEn: "Silver Echo", NameAr: "Silver Echo", HorseNo: 2, OwnerSilkColor: "", votes: 77 },
                { NameEn: "Royal Sand", NameAr: "Royal Sand", HorseNo: 8, OwnerSilkColor: "", votes: 65 },
            ],
        },
        { totalvotes: 230 },
    ],
];

const getFallbackPredictionData = (apiData) => {
    if (Array.isArray(apiData) && apiData.length > 0) {
        return apiData;
    }
    return ENABLE_TEMP_PREDICTION_DATA ? TEMP_PREDICTION_DATA : [];
};

const HomeCenterSubSection = () => {
    const dispatch = useDispatch();
    const { data: PredictionOfHorse, status } = useSelector(
        (state) => state.PredictionOfHorse
    );
   
    const [PredictorData, setPredictionData] = useState(getFallbackPredictionData(PredictionOfHorse));

    useEffect(() => {
        setPredictionData(getFallbackPredictionData(PredictionOfHorse));
      },[PredictionOfHorse])

    useEffect(() => {
        dispatch(fetchPredictionHorse());
        const handlePredictor = (Predictor) => {
            setPredictionData(getFallbackPredictionData(Predictor));
        };

        socket.on("Predictor", handlePredictor);

        return () => {
            socket.off("Predictor", handlePredictor);
        };
       
    }, [dispatch]);

 

    const isActive = PredictorData?.length == 0 ? false : true;

   

    return (
        <div className="center-subsection-revamp">
            {PredictorData && PredictorData.length > 0 ? (
                <Carousel
                    controls={isActive}
                    touch={true}
                >
                    {PredictorData.map((item, i) => {
                        return (

                            <Carousel.Item interval={2000000} key={i}>
                                <div className='graphParent'>
                                    <Graph item={item} />

                                    <Prediction data={item} />

                                </div>

                            </Carousel.Item>


                        );
                    }
                    )}

                </Carousel>
            ) : (
                <NoResultCard title="Pick_Race_Experts" />
            )}
        </div>
    );
};

export default HomeCenterSubSection;
